import { getRuntimeOrigin } from './runtimeOrigin';

/**
 * Builds iframe and script embed snippets — auto height via embed.js resize messages.
 */
export function generateEmbedSnippets(widgetId, config) {
  const origin = getRuntimeOrigin();
  const theme = config.theme || 'dark';

  const iframe = `<!-- Scorewidget embed — height adjusts to content when using script loader -->
<iframe
  src="${origin}/w/${widgetId}?theme=${encodeURIComponent(theme)}"
  width="100%"
  style="min-height:200px;border:0;display:block"
  title="Scorewidget — ${config.name}"
  loading="lazy"
></iframe>`;

  const script = `<!-- Scorewidget embed (recommended — auto height) -->
<div id="sw-widget-${widgetId}"></div>
<script
  async
  src="${origin}/embed.js"
  data-widget-id="${widgetId}"
  data-theme="${theme}"
  data-auto-height="true"
></script>`;

  return { iframe, script };
}
